import en from './lang/en.json'
import zhCN from './lang/zh-CN.json'
import zhTW from './lang/zh-TW.json'

export default {
  en: en,
  zh_cn: zhCN,
  zh_tw: zhTW
}



// WEBPACK FOOTER //
// ./src/assets/locales/index.js